import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={movie.image}
          alt={movie.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
        <div className="absolute top-2.5 left-2.5 flex gap-1.5 flex-wrap">
          {movie.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
              NEW
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              热播
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1.5 mb-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-background-50 font-medium">{movie.rating}</span>
          </div>
          <p className="text-sm text-background-50 font-medium line-clamp-1">{movie.title}</p>
        </div>
      </div>
      <div className="px-0.5">
        <p className="text-xs text-foreground-500">{movie.year} / {movie.duration}</p>
      </div>
    </Link>
  );
}